import React from 'react';
import classNames from 'classnames';
import { COLORS_PROP_TYPE } from '@eventbrite/valkyrie-eds-styles/color';
import { DIVIDER_DIRECTIONS_PROP_TYPE } from './constants';

import styles from './Divider.module.scss';

export class Divider extends React.PureComponent {
  static propTypes = {
    /**
     * Color of divider
     */
    color: COLORS_PROP_TYPE,
    /**
     * Direction of divider (horizontal, vertical)
     */
    direction: DIVIDER_DIRECTIONS_PROP_TYPE,
  };

  static defaultProps = {
    color: 'ui-200',
    direction: 'horizontal',
  };

  render() {
    const { color, direction } = this.props;

    const className = classNames(styles.root, {
      [`eds-bg-color--${color}`]: color, // TODO: Figure out colors
      [styles.horizontal]: direction === 'horizontal',
      [styles.vertical]: direction === 'vertical',
    });

    return (
      <hr className={className} data-spec="divider-hr" aria-hidden="true" />
    );
  }
}
